module.exports = __webpack_public_path__ + "img/icon-chevron-top.43335a4a.svg";